// src/api/modules/FileApi.js
import Methods from "../methods";

const searchAvailableFiles = (context, idClient, process, payload) => {
  const {filters, page, size, sortBy = "registrationDate", direction = "desc"} = payload;
  const url = `files/available/${idClient}/${process}/?page=${page}&size=${size}&sortBy=${sortBy}&direction=${direction}`;
  return Methods.doPost(context, url, filters, null);
};

const searchPickupFiles = (context, payload) => {
  const {idClient, filters, types, page, size, sortBy = "registrationDate", direction = "desc"} = payload;
  const typeList = Array.isArray(types) ? types : (types ? [types] : []);
  const typeParams = typeList.map(type => `types=${encodeURIComponent(type)}`).join("&");
  const params = [
    typeParams,
    `page=${page}`,
    `size=${size}`,
    `sortBy=${sortBy}`,
    `direction=${direction}`
  ].filter(Boolean).join("&");
  const url = `files/client/${idClient}/pickup-search?${params}`;
  return Methods.doPost(context, url, filters, null);
};

const findFilesByBoxes = (context, payload) => {
  const url = `files/by-boxes`;
  return Methods.doPost(context, url, payload, null);
};

export default {
  searchAvailableFiles,
  searchPickupFiles,
  findFilesByBoxes
};



// WEBPACK FOOTER //
// ./src/api/modules/FIleApi.js